import React from 'react';
import { DatePicker } from 'antd';
import moment from 'moment';

const { RangePicker } = DatePicker;

/**
 * Month range picker that returns two dates in onChange,
 * one at the start of first chosen month and another at the end of the second
 */
export default function MonthRangePicker({
  value,
  onChange,
}: {
  value: [Date | null, Date | null] | null;
  onChange: (fromDate: Date, toDate: Date) => void;
}): JSX.Element {
  return (
    <RangePicker
      style={{ borderRadius: 50, padding: '7px 12px' }}
      value={
        value && value[0] && value[1]
          ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ([moment(value[0]), moment(value[1])] as any)
          : null
      }
      format="MMMM YYYY"
      picker="month"
      mode={['month', 'month']}
      onChange={(range): void => {
        if (!range) {
          return;
        }
        const [newDateFrom, newDateTo] = range;
        if (!newDateFrom || !newDateTo) {
          return;
        }

        // Beginning of selected month
        const newDateFromDate = newDateFrom.startOf('month').toDate();
        // End of selected month
        const newDateToDate = newDateTo.endOf('month').toDate();

        onChange(newDateFromDate, newDateToDate);
      }}
    />
  );
}
